"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = CloseCircle;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function CloseCircle(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    id: "Arrows_",
    "data-name": "Arrows+"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "close-circle"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    id: "compound",
    d: "M68.43,35.1,53.54,50,68.43,64.9a2.49,2.49,0,0,1,0,3.53,2.46,2.46,0,0,1-1.76.74,2.5,2.5,0,0,1-1.77-.74L50,53.54,35.1,68.43a2.5,2.5,0,0,1-1.77.74,2.46,2.46,0,0,1-1.76-.74,2.49,2.49,0,0,1,0-3.53L46.46,50,31.57,35.1a2.5,2.5,0,0,1,3.53-3.53L50,46.46,64.9,31.57a2.5,2.5,0,0,1,3.53,3.53ZM92.5,50A42.5,42.5,0,1,1,50,7.5,42.55,42.55,0,0,1,92.5,50Zm-5,0A37.5,37.5,0,1,0,50,87.5,37.54,37.54,0,0,0,87.5,50Z"
  }))));
}